import { render, staticRenderFns } from "./PageBsnWithdraw.vue?vue&type=template&id=0bdeaf16&scoped=true"
import script from "./PageBsnWithdraw.vue?vue&type=script&lang=js"
export * from "./PageBsnWithdraw.vue?vue&type=script&lang=js"
import style0 from "./PageBsnWithdraw.vue?vue&type=style&index=0&id=0bdeaf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdeaf16",
  null
  
)

export default component.exports